import React, { useEffect, useState } from "react";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import Space from "../ui/Space";
import VirtualTable from "../ui/VirtualTable";
import Checkbox from "../ui/Checkbox";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import { InfoIcon, LockIcon } from "../utils/Icons";
import Nav from "../ui/Nav";
import { kbdEvent, permissionLabel } from "../utils/Utils";
import { useSignals } from "@preact/signals-react/runtime";
import EmployeeLogin from "./EmployeeLogin";
import { createModal } from "../hooks/createModal";
import Employee from "./Employee";
import Confirm from "./Confirm";
import TextButton from "../ui/TextButton";

export default function SetupPasswords(props) {

    const { controller = "", signal = {}, value = "", callback = () => { }, route = "", modal = false } = props;
    useSignals();
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState({});
    const [selectedRow, setSelectedRow] = useState({});
    const [left, setLeft] = useState(true);
    const [label, setLabel] = useState({});
    const fetchAuthor = () => {
        pubCall("setting.employee.getAll", {}, (_s, _r) => {
            if (_s) {
                setData(_r)
                if (_r.length > 0) { setSelected(_r[1]) }
            } else {
                showError(_r);
            }
        })
    }
    useEffect(fetchAuthor, [])

    useEffect(() => {
        if (selected?.permissions) {
            let _a = convertPermissionsToArray(selected)
            if (_a.length > 0) { setSelectedRow(_a[0]); } else { setSelectedRow({}); }

        }
    }, [selected])

    const requireLogin = () => {

        window.bm_state.value = ROUTES.GLOBAL.EMPLOYEE_LOGIN;
        createModal({
            component: <EmployeeLogin permission={{ ...signal?.value?.session?.permission, "master": true }} signal={signal} route={ROUTES.GLOBAL.EMPLOYEE_LOGIN} />, closable: true, title: "Login to edit rights", callback: (e) => {
                if (e?.permission?.master) {
                    // has access
                    switchSides(false)
                } else {
                    window.bm_state.value = route;
                }
            }
        })
    }

    const modifyEmployee = (_employee = false) => {
        window.bm_state.value = ROUTES.EMPLOYEE.EDIT;
        createModal({
            component: <Employee employee={_employee} data={data} signal={signal} route={ROUTES.EMPLOYEE.EDIT} />, closable: true, title: "Employee", callback: (e) => {
                if (e) {
                    if (!_employee) {
                        let _d = [...data];
                        _d.push(e);
                        setData(_d);
                        setSelected(e);
                        showMessage("Employee updated successfully");
                    } else {
                        updateRow(e);
                    }
                }
                window.bm_state.value = route;
            }
        })
    }

    const deleteEmployee = (_employee = false) => {
        window.bm_state.value = ROUTES.HELPERS.CONFIRM;
        createModal({
            alert: true,
            component: <Confirm controller={controller} description={
                <div style={{ "textAlign": "center" }}>
                    <div className="shim" />
                    <div style={{ "margin": "0 auto", "width": "160px", "textAlign": "center" }}>
                        <TextButton onClick={() => kbdEvent(KBD.Y)}><strong>Y</strong>es</TextButton>
                        &nbsp;
                        <TextButton onClick={() => kbdEvent(KBD.N)} ><strong>N</strong>o</TextButton>
                    </div>
                </div>
            } signal={signal} route={ROUTES.HELPERS.CONFIRM} />, closable: true, title: "Delete this entry?", callback: (e) => {
                if (e) {
                    pubCall("setting.employee.delete", { clerk_code: _employee?.clerk_code }, (_s, _r) => {
                        if (_s) {
                            updateRow(_employee, false, true);
                            showMessage("Employee deleted successfully");
                        } else {
                            showError(_r);
                        }
                    })
                }
                window.bm_state.value = route;
            }
        })
    }

    const switchSides = (_left = true) => {
        if (_left) {
            window.bm_state.value = route;
            setLeft(_left);
        } else {
            if (signal?.value?.session?.permission?.master) {
                window.bm_state.value = ROUTES.GLOBAL.SETUP_PASSWORDS_RIGHT;
                setLeft(_left);
            } else {
                requireLogin();
            }
        }
    }

    const nav = [
        // { key: KBD.H, text: "Hst", action: () => showHistoryFilters() },
        { text: "Del", key: KBD.D, action: () => deleteEmployee(selected) },
        { text: "Edit", key: KBD.E, action: () => modifyEmployee(selected) },
        { text: "New", key: KBD.N, action: (e) => modifyEmployee() },
        { text: "Password" },
        { text: "Rights", key: KBD.R, action: (e) => switchSides(false) },
        { text: "XPassword" },
    ]

    const updatePermission = (_dont) => {

        let _p = { ...selectedRow }
        let _s = { ...selected };

        let _isme = (selected.clerk_code === signal?.value?.session?.clerk_code);
        _s.permissions[_p.permission] = !_p.value;
        let _obj = { permission: _p.permission, value: _s.permissions[_p.permission] }

        pubCall("setting.employee.edit", { employee: _s }, (_s, _r) => {
            if (_s) {

                if (_isme || selected.is_master) {
                    pubCall("session.get", {}, (_status, _result) => {
                        if (_status) {
                            signal.value = { ...signal.value, "session": _result }
                            if (!signal?.value?.session?.permission?.master) {
                                switchSides(true);
                            }
                            updateRow(_r, _obj);
                        }
                    })
                } else {
                    updateRow(_r, _obj);
                }



            } else {
                showError(_r);
            }
        })
    }

    const updateRow = (_row, _obj = false, _delete = false) => {
        let _d = [...data];

        // Delete
        if (_delete) {
            _d = _d.filter(item => item.clerk_code !== _row.clerk_code);
            setData(_d);
            if (_d.length > 0) {
                setSelected(_d[0])
            } else {
                setSelected({});
            }
            return;
        }

        let _f = _d.findIndex(item => item.clerk_code === _row.clerk_code);
        if (_f > -1) {



            _d[_f] = _row;
            setData(_d);
            //setSelected(_row);
            if (_obj) {
                setSelectedRow(_obj)
            }
        }
    }


    useEffect(() => {
        const actions = [
            { key: KBD.ENTER, action: (e) => { updatePermission({ ...selectedRow }) } },
            { key: KBD.ESCAPE, action: (e) => { callback() } },
            { key: KBD.ARROW_LEFT, action: (e) => { switchSides(true) } },
        ];
        const cleanup = listen(controller, ROUTES.GLOBAL.SETUP_PASSWORDS_RIGHT, actions, false);
        return cleanup;
    }, [selected, selectedRow, nav]);

    useEffect(() => {
        const actions = [
            { key: KBD.ENTER, action: (e) => { switchSides(false) } },
            { key: KBD.ESCAPE, action: (e) => { callback() } },
            { key: KBD.ARROW_RIGHT, action: (e) => { switchSides(false) } },
        ];
        const cleanup = listen(controller, route, actions.concat(nav), false);
        return cleanup;
    }, [selected, selectedRow]);




    const employee_columns = [
        { key: "has_password", align: "center", title: <>{<LockIcon />}</>, width: 25 },
        { key: "clerk_code", align: "center", title: <>Code</>, width: 35 },
        {
            key: "name", align: "left", title: <>Name</>, width: 230, render: (e, f) => {
                return (f.is_master) ? "*** Master ***" : e;
            }
        },
    ]

    const permission_columns = [
        {
            key: "value", align: "center", title: <></>, width: 25, render: (e, f) => {
                return <Checkbox onChange={(e) => updatePermission(f)} value={e} />
            }
        },
        {
            key: "permission", align: "left", title: <>Permissions</>, width: 352, render: (e) => {
                return permissionLabel(e);
            }
        },
    ]

    const next = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const currentIndex = data.findIndex(item => item?.clerk_code === selected?.clerk_code);
        const nextIndex = Math.min(currentIndex + _rows, data.length - 1);
        setSelected(data[nextIndex]);
    };

    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const currentIndex = data.findIndex(item => item?.clerk_code === selected?.clerk_code);
        const prevIndex = Math.max(currentIndex - _rows, 0);
        setSelected(data[prevIndex]);

    };

    const nextTitle = (_rows = 1) => {
        let _arr = convertPermissionsToArray(selected);
        if (_arr.length === 0) { setSelectedRow({}); return; }
        const currentIndex = _arr.findIndex(item => item?.permission === selectedRow?.permission);
        const nextIndex = Math.min(currentIndex + _rows, _arr.length - 1);
        setSelectedRow(_arr[nextIndex]);
    };

    const prevTitle = (_rows = 1) => {
        let _arr = convertPermissionsToArray(selected);
        if (_arr.length === 0) { setSelectedRow({}); return; }
        const currentIndex = _arr.findIndex(item => item?.permission === selectedRow?.permission);
        const prevIndex = Math.max(currentIndex - _rows, 0);
        setSelectedRow(_arr[prevIndex]);
    };

    const convertPermissionsToArray = (_sel = {}, master = false) => {

        if (master) {
            return Object.keys(_sel?.permissions || {}).map(key => {
                return {
                    permission: key,
                    value: _sel?.permissions[key],
                }
            })
        }

        return Object.keys(_sel?.permissions || {}).map(key => {
            return {
                permission: key,
                value: _sel?.permissions[key],
                show: (data[0].permissions[key] || _sel?.is_master)
            }

        }).filter(item => item.show);
    };

    const draw = () => {
        return (
            <div style={{ "padding": (modal) ? "0px" : "0px 5px", "paddingBottom": (modal) ? "0px" : "5px" }}>
                <div className="shim" />
                <Space>
                    <div style={{ "opacity": (!left) ? "0.7" : "1" }} onClick={() => switchSides(true)}>
                        <VirtualTable
                            controller={controller}
                            row_key={"clerk_code"}
                            next={next}
                            prev={prev}
                            route={route}
                            current={selected}
                            data={data}
                            width={250}
                            height={388}
                            offset={0}
                            columns={employee_columns}
                            onRowClick={(item, event, index) => { switchSides(true); setSelected(item) }}
                        />
                    </div>

                    <div style={{ "opacity": (left) ? "0.7" : "1" }} onClick={() => switchSides(false)}>
                        <VirtualTable
                            controller={controller}
                            row_key={"permission"}
                            align="none"
                            next={nextTitle}
                            prev={prevTitle}
                            onRowClick={(item) => { if (left) { kbdEvent(KBD.ARROW_LEFT) } setSelectedRow(item) }}
                            onRowDoubleClick={(_p) => { updatePermission(_p); }}
                            route={ROUTES.GLOBAL.SETUP_PASSWORDS_RIGHT}
                            current={selectedRow}
                            data={convertPermissionsToArray(selected)}
                            width={400}
                            height={388}
                            offset={0}
                            columns={permission_columns}
                        />
                    </div>

                </Space>
                <Nav nav={nav} />
                <div className="shim" /><div className="shim" />

                {/* <Status><InfoIcon />[TODO]</Status> */}
            </div>
        )
    }



    return <><div className="shim" />{draw()}</>;


}

